import { render } from "./CentersForm.vue?vue&type=template&id=6878edb5&scoped=true"
import script from "./CentersForm.vue?vue&type=script&lang=js"
export * from "./CentersForm.vue?vue&type=script&lang=js"

import "./CentersForm.vue?vue&type=style&index=0&id=6878edb5&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6878edb5"]])

export default __exports__